import changeIsLoading from '../../actions/changeIsLoading';
import initializeSignatureViewState from '../../actions/signature/initializeSignatureViewState';
import loadSignatureOption from '../../actions/signature/loadSignatureOption';
import SignatureViewState from '../../store/schema/SignatureViewState';
import updateSignatureViewState from '../../actions/signature/updateSignatureViewState';
import { orchestrator } from 'satcheljs';
import {
    getEmailSignaturePreferenceFromCache,
    loadEmailSignaturePreferences,
} from 'mini-mail-signature';

const loadSignatureOptionOrchestrator = orchestrator(loadSignatureOption, async () => {
    // initialize the view state
    initializeSignatureViewState();

    // show loading indicator
    changeIsLoading(true);

    // fetch the signature preferences from server only if it's not fetched already
    if (!getEmailSignaturePreferenceFromCache()) {
        // load user's signature preference from the server to UI cache
        await loadEmailSignaturePreferences();
    }

    const emailSignaturePreference = getEmailSignaturePreferenceFromCache();
    // update the viewState locally
    emailSignaturePreference &&
        updateSignatureViewState({
            useDesktopSignature: emailSignaturePreference.UseDesktopSignature,
        } as SignatureViewState);

    // remove loading indicator
    changeIsLoading(false);
});

export default loadSignatureOptionOrchestrator;
